import React from 'react';

import classes from './CardHeader.module.scss';

const CardHeader = () => {
  return (
    <div className={classes.cardHeader}>
      <h1>Welcome to GitHub Lookup!</h1>
    </div>
  );
};

export default CardHeader;
